import React from 'react'
import { Link } from 'react-router-dom'

function Not_Available_With_Current_Plan() {
  return (
    <>
    <div className='npt fc'>
      <h2>
      Not Available With Current Plan
      </h2>
      {/* <p><Link to="/pricing" className='btn btn-secondary'>Upgrade Plan</Link></p> */}
    </div>
    </>
  )
}

export default Not_Available_With_Current_Plan